export default function StatusBadge({ status, t }) {
  const styles = {
    pending: "bg-yellow-100 text-yellow-900",
    reviewed: "bg-sky-100 text-sky-900",
    interview: "bg-indigo-100 text-indigo-900",
    rejected: "bg-red-100 text-red-900",
    hired: "bg-green-100 text-green-900",
    active: "bg-green-100 text-green-900",
    inactive: "bg-slate-100 text-slate-600",
  };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center rounded-full border border-slate-900 px-2.5 py-0.5 text-xs font-semibold ${styles[status] || "bg-slate-100 text-slate-900"}`}
    >
      {t(`status.${status}`)}
    </span>
  );
}
